import React, { useEffect, useMemo, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import { Col, Divider, message, Modal, Row, Spin } from "antd";
import Text from "../../components/Text/Text";
import Button from "../../components/Button/Button";
import image from "../../resource/image";
import EmptyData from "../../components/EmptyState/EmptyData";
import ModalApproveGroup from "../../components/Modal/ModalApproveGroup";
import OverCreditContent from "./OverCreditContent";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import {
  createOverCreditApprove,
  deleteGroup,
  getOverCreditApproveByComp,
  updateOverCreditApprove,
} from "../../datasource/OverCreditApproveDatasource";
import {
  AllOverCreditApprovedEntities_INIT,
  OverCreditApprovedEntities_INIT,
  sequencesEntities_INIT,
  type AllOverCreditApprovedEntities,
  type OverCreditApprovedEntities,
  type sequencesEntities,
} from "../../entities/OverCreditApproveEntity";
import moment from "moment";

function SettingOverCredit() {
  const [overCreditApproved, setOverCreditApproved] = useState<AllOverCreditApprovedEntities>(
    AllOverCreditApprovedEntities_INIT,
  );
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [modalAdd, setModalAdd] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [sequences, setSequences] = useState<sequencesEntities[]>([
    sequencesEntities_INIT,
    sequencesEntities_INIT,
  ]);
  const [selectedGroupForEdit, setSelectedGroupForEdit] = useState<OverCreditApprovedEntities>(
    OverCreditApprovedEntities_INIT,
  );
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const isTempId = (id: string) => id.startsWith("temp-");

  const getOverCreditApproved = async () => {
    try {
      await getOverCreditApproveByComp(profile.company).then((res) => {
        const updatedSequences: OverCreditApprovedEntities[] = res?.data.map((group: any) => {
          const seq = [...(group.sequences || [])];

          if (seq.length > 1 && seq[1]?.percent !== undefined) {
            seq[0] = {
              ...seq[0],
              percent: seq[1].percent,
            };
          }

          return {
            ...group,
            sequences: seq,
          };
        });
        const finalData: AllOverCreditApprovedEntities = {
          data: updatedSequences,
          updateBy: res?.updateBy,
          updateDate: res?.updateDate,
        };
        setOverCreditApproved(finalData);
      });
    } catch (error) {
      console.log("err get over credit approve by comp", error);
    }
  };
  useEffect(() => {
    getOverCreditApproved();
  }, []);

  const handleDelete = async (id: any) => {
    if (!id) {
      setOverCreditApproved((prev) => ({
        ...prev,
        data: [],
      }));
    } else {
      const updateBy = `${profile.firstname} ${profile.lastname}`;
      if (typeof id === "number") {
        setOverCreditApproved((prev) => ({
          ...prev,
          data: prev.data.filter((_, index) => index !== id),
        }));
        return;
      }
      Modal.confirm({
        title: "ยืนยันการลบ",
        content: "กลุ่มอนุมัติจะถูกลบออกจากระบบ",
        okText: "ลบ",
        cancelText: "ยกเลิก",
        okButtonProps: { danger: true },
        onOk: async () => {
          try {
            await deleteGroup(id, updateBy);
            setOverCreditApproved((prev) => ({
              ...prev,
              data: prev.data.filter((item) => item.overCreditApproverGroupId !== id),
            }));
            message.success("ลบกลุ่มสำเร็จ");
          } catch (error) {
            console.error("ลบไม่สำเร็จ", error);
            message.error("เกิดข้อผิดพลาดระหว่างลบ");
          }
        },
      });
    }
  };

  const handleEdit = (val: any) => {
    setSelectedGroupForEdit(val);
    setModalAdd(true);
  };

  const handleSaveAll = async () => {
    const updateBy = `${profile.firstname} ${profile.lastname}`;
    const cleanAndSetUpdateBy = (obj: any, updateByValue: string): any => {
      if (Array.isArray(obj)) {
        return obj.map((item) => cleanAndSetUpdateBy(item, updateByValue));
      } else if (obj && typeof obj === "object") {
        const newObj: any = {};
        for (const key in obj) {
          let val = obj[key];

          if (val === "") {
            val = undefined;
          } else if (typeof val === "object" && val !== null) {
            val = cleanAndSetUpdateBy(val, updateByValue);
          }

          newObj[key] = val;
        }
        newObj.updateBy = updateByValue;
        return newObj;
      }
      return obj;
    };

    const clearTempGroupId = (groups: any[]) => {
      return groups.map((group) => {
        const newGroup = { ...group };
        if (
          typeof newGroup.overCreditApproverGroupId === "string" &&
          newGroup.overCreditApproverGroupId.startsWith("temp-")
        ) {
          newGroup.overCreditApproverGroupId = undefined;
        }
        return newGroup;
      });
    };
    setLoadingSave(true);
    try {
      let cleanedSequences = cleanAndSetUpdateBy(sequences, updateBy);
      cleanedSequences = clearTempGroupId(cleanedSequences);
      const hasAnyGroupId = cleanedSequences.some(
        (group: any) => !!group.overCreditApproverGroupId,
      );
      const payload = cleanedSequences?.map((group: any) => ({
        ...group,
        sequences: group.sequences?.map((seq: any, index: number) =>
          index === 0 ? { ...seq, percent: "0" } : seq,
        ),
      }));

      if (payload.length >= 1 && hasAnyGroupId) {
        await updateOverCreditApprove({
          groups: [...payload],
          updateBy,
          company: profile?.company,
        });
        message.success("บันทึกเรียบร้อยแล้ว");
      } else {
        for (const group of payload) {
          await createOverCreditApprove({
            ...group,
            createBy: updateBy,
          });
        }
        message.success("บันทึกเรียบร้อยแล้ว");
      }
    } catch (error) {
      console.error("เกิดข้อผิดพลาดระหว่างบันทึก:", error);
      message.error("เกิดข้อผิดพลาดระหว่างบันทึก กรุณาลองใหม่อีกครั้ง");
    } finally {
      await getOverCreditApproved();
      setTimeout(() => {
        setLoadingSave(false);
      }, 700);
    }
  };

  const isAddDisabled =
    overCreditApproved.data.length > 0 &&
    overCreditApproved.data.every(
      (item) => !item.overCreditApproverGroupId || isTempId(item.overCreditApproverGroupId),
    );

  return (
    <CardContainer>
      {loadingSave && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size='large' tip='กำลังบันทึกข้อมูล...' />
        </div>
      )}
      <Row align='middle' gutter={16} justify='space-between' style={{ marginBottom: "28px" }}>
        <Col className='gutter-row'>
          <Text fontSize={24} fontWeight={700} color='Text1'>
            ตั้งค่าอนุมัติวงเงินเกิน
          </Text>
          <br />
          {overCreditApproved.updateDate && (
            <Text fontFamily='Sarabun' fontSize={12} fontWeight={400}>
              อัปเดตล่าสุดเมื่อ&nbsp;
              {moment(overCreditApproved.updateDate).format("DD/MM/YYYY, HH:mm น.")} โดย&nbsp;
              {overCreditApproved.updateBy}
            </Text>
          )}
        </Col>
        <Col className='gutter-row'>
          <Button
            title='+ เพิ่มเกณฑ์อนุมัติ'
            onClick={() => setModalAdd(true)}
            typeButton={isAddDisabled ? "disabled" : "primary"}
            disabled={isAddDisabled}
          />
        </Col>
      </Row>

      {overCreditApproved.data.length > 0 ? (
        <>
          <OverCreditContent
            data={overCreditApproved.data}
            callBackUpdate={(e: any) => {
              setSequences(e);
            }}
            callErrForm={(err) => setIsSaveDisabled(err)}
            handleDelete={(id) => handleDelete(id)}
            handleEdit={(val) => handleEdit(val)}
          />
          <Divider />
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <Button
              typeButton={!isSaveDisabled ? "disabled" : "primary"}
              title='บันทึก'
              style={{ width: "135px" }}
              onClick={() => setVisible(true)}
              disabled={!isSaveDisabled}
            />
          </div>
        </>
      ) : (
        <EmptyData
          text='ยังไม่พบกลุ่มการอนุมัติ'
          img={image.emptyShopTable}
          widthImg='170px'
          heightImg='110px'
        />
      )}
      <ModalApproveGroup
        open={modalAdd}
        groupData={selectedGroupForEdit}
        onClose={() => {
          setModalAdd(false);
          setSelectedGroupForEdit(OverCreditApprovedEntities_INIT);
        }}
        onSubmit={(data) => {
          setOverCreditApproved((prev) => {
            const updatedData = [...prev.data];

            const indexToUpdate = updatedData.findIndex(
              (item) => item.overCreditApproverGroupId === data.overCreditApproverGroupId,
            );
            const existingSequences =
              indexToUpdate !== -1 ? updatedData[indexToUpdate].sequences : data.sequences;
            const formattedData = {
              ...data,
              sequences:
                existingSequences && existingSequences.length > 0
                  ? existingSequences
                  : [{ ...sequencesEntities_INIT }, { ...sequencesEntities_INIT }],
              createDate: new Date().toISOString(),
              updateDate: new Date().toISOString(),
              isDelete: false,
            };

            if (indexToUpdate !== -1) {
              updatedData[indexToUpdate] = {
                ...updatedData[indexToUpdate],
                ...formattedData,
              };
            } else {
              updatedData.push(formattedData);
            }

            return {
              ...prev,
              data: updatedData,
            };
          });

          setModalAdd(false);
          setSelectedGroupForEdit(OverCreditApprovedEntities_INIT);
        }}
        callBackData={overCreditApproved.data}
      />

      <ConfirmModal
        visible={visible}
        loading={loadingSave}
        onConfirm={async () => {
          await handleSaveAll();
          setVisible(false);
        }}
        onCancel={() => setVisible(false)}
        title='ยืนยันการบันทึกตั้งค่าอนุมัติวงเงินเกิน'
        desc='โปรดตรวจสอบรายละเอียดการตั้งค่าอนุมัติอีกครั้งก่อนกดยืนยัน เพราะอาจส่งผลต่อการแสดงผลการอนุมัติวงเงินเกินในระบบ'
      />
    </CardContainer>
  );
}

export default SettingOverCredit;
